import { token } from '../../localStorage'
import { BASE_URL } from '../constants'

export const tickets = ({ page = 0 }) => {
  const URL = `${BASE_URL}tickets/list?page=${page ?? 0}&typeTicket`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    }).then((response) => response.json())

    return response
  } catch (error) {
    console.log(error)
  }
}
